export const ROUTES = { HOME: '/' };
